import React from 'react'
import PropTypes from 'prop-types'
import StarRatings from 'react-star-ratings'
import CommentIconWithDialog from './CommentIconWithDialog'
import css from './review-response.css'

const ReviewResponse = ({
  review,
  review: {
    positive,
    stars,
    comment,
  },
}) => {
  let responseIcon
  if (positive !== null) {
    responseIcon = (
      <img
        src={positive ?
          '/images/thumbs-up.svg' :
          '/images/thumbs-down.svg'
        }
        alt="Review"
      />
    )
  } else if (stars !== null) {
    responseIcon = (
      <StarRatings
        rating={stars}
        numberOfStars={5}
        starDimension="15px"
        starSpacing="1px"
        starRatedColor="#FFBF00"
      />
    )
  }

  return responseIcon ? (
    <span className={css.reviewResponse}>
      <div className={css.responseIcon}>
        {responseIcon}
      </div>
      <div className={css.commentIcon}>
        {!!comment && (
          <CommentIconWithDialog review={review} />
        )}
      </div>
    </span>
  ) : null
}

ReviewResponse.propTypes = {
  review: PropTypes.shape({
    positive: PropTypes.bool,
    stars: PropTypes.number,
    comment: PropTypes.string,
  }),
}

export default ReviewResponse



// WEBPACK FOOTER //
// ./src/components/sitewide/Reviews/ReviewResponse.js